import React from "react";
import { graphql, Script } from "gatsby";
import { useSiteMetadata } from "../hooks/use-site-metadata";
import { isBrowser } from '../libs/helpers'

const Seo = ({ metaDescription, metaImage, metaTitle, location, children }) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    siteUrl,
  } = useSiteMetadata();

  const seo = {
    title: metaTitle || defaultTitle,
    description: metaDescription || defaultDescription,
    image: metaImage?.url || `${image.url}`,
    // returns the full url https://www.medicineandthemilitary.com/ with the pathname
    url:
      location && location.pathname
        ? `${siteUrl}${location.pathname}`
        : siteUrl,
  };

  let beacon = <Script id="beacon" type="text/javascript">{`(function(d,e,j,h,f,c,b){d.SurveyGizmoBeacon=f;d[f]=d[f]||function(){(d[f].q=d[f].q||[]).push(arguments)};c=e.createElement(j),b=e.getElementsByTagName(j)[0];c.async=1;c.src=h;b.parentNode.insertBefore(c,b)})(window,document,'script','//d2bnxibecyz4h5.cloudfront.net/runtimejs/intercept/intercept.js','sg_beacon'); sg_beacon('init','NzQ4MzI3LTU3ZjQ0NGY4MTZhN2RjZTNmMWE3YzgxZGUwNmFmNTY2YjkzMjE1ZDg1MzM2NmNkZjU0');`}</Script>
  if (isBrowser) {
    // TODO: replace with process.env somehow?
    if (window.location.href.startsWith('https://www.medicineandthemilitary.com/')) {
      beacon = <Script id="beacon" type="text/javascript">{`(function(d,e,j,h,f,c,b){d.SurveyGizmoBeacon=f;d[f]=d[f]||function(){(d[f].q=d[f].q||[]).push(arguments)};c=e.createElement(j),b=e.getElementsByTagName(j)[0];c.async=1;c.src=h;b.parentNode.insertBefore(c,b)})(window,document,'script','//d2bnxibecyz4h5.cloudfront.net/runtimejs/intercept/intercept.js','sg_beacon'); sg_beacon('init','NzQ4MzI3LTc2MDI3YmNkNTA4ZTFhMDAxZDlkZTU2Nzk2ZTgzYjI4OWI4M2IwNTNhYzllZTZkZDg2');`}</Script>
    }
  }

  return (
    <>
      <html lang="en" />
      <title>{seo.title}</title>
      <link
        rel="shortcut icon"
        href="https://cdn.medicineandthemilitary.com/favicon.ico"
        type="image/vnd.microsoft.icon"
      />
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.image} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:site_name" content="Medicine + The Military" />
      <link rel="stylesheet" type="text/css" href="https://cloud.typography.com/7367712/646324/css/fonts.css" />
      { beacon }
      { children }
    </>
  );
};

export default Seo;

export const query = graphql`
  fragment SeoData on STRAPI__COMPONENT_SHARED_SEO {
    id
    metaTitle
    metaDescription
    metaImage {
      url
      name
      alternativeText
    }
  }
`;
